import { get, post } from '~shared/utils/http';
import {
    EVENTS_ENDPOINT,
    SCHEDULED_EVENTS_ENDPOINT,
    INDEX_ROUTE,
    DEFAULT_SCHEDULED_EVENTS_DATE,
    SELECTION_REORDER_ENDPOINT,
} from './constants';
import { buildSpectateUrl } from '~spa/Utils/Spectate';

/**
 * Get initial inplay state
 * @param {String} [filter=INDEX_ROUTE] Optional sport filter
 * @return {Promise.<data, Error>} returns a promise that resolves with the data
 * as json or rejects with an error object
 */
export const getInitialState = (filter = INDEX_ROUTE) => (
    get(buildSpectateUrl(
        `${EVENTS_ENDPOINT}/${filter}`
    )).then(response => response.json())
);

/**
 * Get scheduled events
 * @param {String} [date=DEFAULT_SCHEDULED_EVENTS_DATE] Optional date filter
 * @return {Promise.<data, Error>} returns a promise that resolves with the data
 * as json or rejects with an error object
 */
export const getScheduledEvents = (date = DEFAULT_SCHEDULED_EVENTS_DATE) => (
    get(
        buildSpectateUrl(`${SCHEDULED_EVENTS_ENDPOINT}?date=${encodeURIComponent(date)}`)
    ).then(response => response.json())
);

/**
 * Reorder Selections
 * @param {Object} [data] selections to be reordered
 * {
 *      selections: {
 *          <market_id>: {
 *              <sel1_id>: { ...selection... },
 *              <sel2_id>: { ...selection... },
 *          }
 *      }
 *      selectionSchemas: {
 *          <market_id>: { selection_schema: <selectionSchema> }
 *      }
 * }
 * @return {Promise.<data, Error>} returns a promise that resolves with the data
 * as json or rejects with an error object
 */
export const getSelectionOrder = (data) => post(buildSpectateUrl(SELECTION_REORDER_ENDPOINT), data).then(response => response.json());
